import { render } from "./TodaysCalls.vue?vue&type=template&id=6162798c&scoped=true"
import script from "./TodaysCalls.vue?vue&type=script&lang=js"
export * from "./TodaysCalls.vue?vue&type=script&lang=js"

import "./TodaysCalls.vue?vue&type=style&index=0&id=6162798c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6162798c"]])

export default __exports__